module.exports = {"130207103":"小集镇","130207104":"黄各庄镇","130207105":"西葛镇","130207106":"大新庄镇","130207107":"钱营镇","130207108":"唐坊镇","130207109":"王兰庄镇","130207110":"柳树酄镇","130207111":"黑沿子镇","130207113":"丰南镇","130207114":"大齐各庄镇","130207115":"岔河镇","130207201":"南孙庄乡","130207202":"东田庄乡","130207203":"尖字沽乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130207.json
// module id = 85
// module chunks = 0